<template>
  <div class="EditSceneButtonWidget lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="EditSceneButtonWidget-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="EditSceneButtonWidget-main lxn-pos-rel">
      <div class="EditSceneButtonWidget-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.EditWidget_title1}}
          </template>
          <template v-slot:body>
            <div class="EditSceneButtonWidget-wrapper-colors lxn-w100">
              <div @click="activeBoxIndex = 0;" class="EditSceneButtonWidget-color color1 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(0)" :class="isBoxActive(0)">
                <div class="EditSceneButtonWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 1;" class="EditSceneButtonWidget-color color2 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(1)" :class="isBoxActive(1)">
                <div class="EditSceneButtonWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 2;" class="EditSceneButtonWidget-color color3 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(2)" :class="isBoxActive(2)">
                <div class="EditSceneButtonWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 3;" class="EditSceneButtonWidget-color color4 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(3)" :class="isBoxActive(3)">
                <div class="EditSceneButtonWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 4;" class="EditSceneButtonWidget-color color5 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(4)" :class="isBoxActive(4)">
                <div class="EditSceneButtonWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
            </div>
            <div class="EditSceneButtonWidget-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.Name_text}}
            </div>
            <div class="lxn-w100">
              <customInput @focus="input1State='active'" @blur="input1State=''" :inputState="input1State" v-model="WidgetName" bgColor="#FFFFFF" :placeHolder="$store.getters.language.texts.WidgetName_PlaceHolder" inputType="text" />
            </div>
            <div class="AddSingleSwitchWidget-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.Folder_text}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="targetFolder" :dropDownContex="dropDownTargetFolder" />
            </div>
          </template>
        </TitleBox>
        <CommandCreator v-model="generatedCommand" :titleBgColor="titleBgColor" :multiHub="true" :outputsOnly="true" :loadFrom="loadedCommand" />
      </div>
      <div class="EditSceneButtonWidget-button lxn-margin-auto lxn-w100">
        <CustomButton @click="saveChanges" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.EditSceneButtonWidget_button}}
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CommandCreator from '@/components/CommandCreator.vue'
import CustomButton from '@/components/CustomButton.vue'
import CustomCurve from '@/components/CustomCurve.vue'
import CustomInput from '@/components/CustomInput.vue'
import DropDown from '@/components/DropDown.vue'
import TitleBox from '@/components/TitleBox.vue'
import TopNav from '@/components/TopNav.vue'

export default {
  name: 'EditSceneButtonWidget',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    CustomInput,
    CommandCreator,
    DropDown
  },
  data: function () {
    return {
      widget: this.$store.state.widgets[this.$route.params.widgetIndex],
      WidgetName: '',
      input1State: '',
      activeBoxIndex: 0,
      generatedCommand: [],
      loadedCommand: [],
      targetFolder: 0,
      folderList: [],
    }
  },
  mounted: function () {
    this.WidgetName = this.widget.name;
    this.activeBoxIndex = this.widget.color;

    for(var i = 0; i < this.widget.settings.commands.length; i++){
      for(var j = 0; j < this.widget.settings.commands[i].actions.length; j++){
        var hub = this.$store.getters.getHubByUUID(this.widget.settings.commands[i].hubUUID);
        var node = this.$store.getters.getNodeByUUID(this.widget.settings.commands[i].actions[j].nodeUUID);
        var state = this.widget.settings.commands[i].actions[j].state;
        var delay = this.widget.settings.commands[i].actions[j].timeDelay;
        var output = null;
        var outputFound = false;
        if(this.widget.settings.commands[i].actions[j].outputType == "IrDevice"){
          for(var k = 0; k < node.outputs.length; k++){
            if(node.outputs[k].settings.brand == this.widget.settings.commands[i].actions[j].outputSettings.brand && node.outputs[k].settings.deviceType == this.widget.settings.commands[i].actions[j].outputSettings.deviceType && node.outputs[k].settings.model == this.widget.settings.commands[i].actions[j].outputSettings.model){
              output = node.outputs[k];
              outputFound = true;
              break;
            }
          }
        }else{
          for(k = 0; k < node.outputs.length; k++){
            if(node.outputs[k].parameterId == this.widget.settings.commands[i].actions[j].parameterId){
              output = node.outputs[k];
              outputFound = true;
              break;
            }
          }
        }
        if(outputFound){
          this.loadedCommand.push({
            hub: hub,
            node: node,
            output: output,
            state: state,
            delay: delay
          });
        }
      }
    }

    for(let i = 0; i < this.folderList.length; i++){
      if(this.folderList[i].path == this.widget.path){
        this.targetFolder = i;
      }
    }
  },
  watch: {
  },
  computed: {
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.activeBoxIndex];
    },
    dropDownTargetFolder: function () {
      this.folderListCleaner();
      var dropDownTargetFolder = {
        name: "AddSingleSwitchWidget-TargetOutputNoNc",
        title: this.$store.getters.language.texts.ChooseOutput_text,
        selectedIndex: this.targetFolder,
        data: [
          {
            name: this.$store.getters.language.texts.Root_text,
            icon: 'folder',
          },
        ]
      };
      this.folderListSetter(
        {
          widgetIndex: -1,
        }
      );
      for(var i = 0; i < this.$store.state.widgets.length; i++){
        if(this.$store.state.widgets[i].type == "folderWidget"){
          var folderWidget = this.$store.state.widgets[i];
          var parentPath = folderWidget.settings.parent;
          var parentFolder = this.$store.state.widgets.filter(widget => widget.settings.path == parentPath);
          var folderName = folderWidget.name;
          while(parentFolder.length){
            folderName = parentFolder[0].name + " > " + folderName;
            parentPath = parentFolder[0].settings.parent;
            parentFolder = this.$store.state.widgets.filter(widget => widget.settings.path == parentPath);
          }
          this.folderListSetter(
            {
              path: folderWidget.settings.path,
            }
          );
          dropDownTargetFolder.data.push({
            name: folderName,
            icon: "folder",
          })
        }
      }
      return dropDownTargetFolder;
    },
  },
  methods: {
    folderListSetter: function (obj) {
      this.folderList.push(obj);
    },
    folderListCleaner: function () {
      this.folderList = [];
    },
    goBack: function () {
      this.$router.go(-1);
    },
    boxStyle: function (boxIndex) {
      return "background-color: " + this.$store.state.themeMainColors[boxIndex];
    },
    isBoxActive: function (boxIndex) {
      if(this.activeBoxIndex == boxIndex) {
        return 'active';
      }else{
        return '';
      }
    },
    saveChanges: function () {
      this.input1State = '';
      if(this.WidgetName == ''){
        this.input1State = 'error';
        alert(this.$store.getters.language.texts.WidgetName_alert);
      }else if(this.generatedCommand.length == 0){
        alert(this.$store.getters.language.texts.CommandCreator_alert2);
      }else{
        this.$store.commit('setAppBusy', true);
        var hubUUIDs = [];
        for(var i = 0; i < this.generatedCommand.length; i++){
          hubUUIDs.push(this.generatedCommand[i].hubUUID);
        }
        var path = this.folderList[this.targetFolder].path;
        var widget = {
          name: this.WidgetName,
          color: this.activeBoxIndex,
          type: "sceneButtonWidget",
          hubUUIDs: hubUUIDs,
          //For compatibility with other widgets
          hubUUID: hubUUIDs[0],
          visible: true,
          path: path,
          settings: {
            commands: this.generatedCommand,
          }
        };
        this.$store.commit('editWidget', {
          widgetIndex: this.$route.params.widgetIndex,
          widget: widget,
        });
        this.$store.commit('saveState');
        this.$router.push('/home/dashboard/');
        this.$store.commit('setAppBusy', false);
      }
    },
  }
}
</script>

<style>
  .EditSceneButtonWidget-topCurve-wrapper {
    height: 200px;
  }
  .EditSceneButtonWidget-main {
    z-index: 2;
  }
  .EditSceneButtonWidget-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .EditSceneButtonWidget-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .EditSceneButtonWidget-wrapper-colors {
    height: 50px;
  }
  .EditSceneButtonWidget-color {
    width: calc((100% - 32px)/5);
    margin-left: 8px;
    padding: 5px;
  }
  .EditSceneButtonWidget-selectedColor {
    background-color: transparent;
    border-style: solid;
    border-color: #FFFFFF;
    border-width: 4px;
    opacity: 0;
  }
  .EditSceneButtonWidget-color.active .EditSceneButtonWidget-selectedColor {
    opacity: 1;
  }
  .EditSceneButtonWidget-color:last-child {
    width: calc((100% - 32px)/5);
    margin-left: 0;
  }
  .EditSceneButtonWidget-wrapper-name-text {
    height: 50px;
    padding-top: 20px;
    line-height: 30px;
    color: #52626C;
  }
  .EditSceneButtonWidget-wrapper-name-text:first-child {
    height: 30px;
    padding-top: 0;
  }
  .EditSceneButtonWidget-wrapper-fieldTitles {
    height: 30px;
    line-height: 30px;
    color: #52626C;
  }
  .EditSceneButtonWidget-commandDelay-button {
    -webkit-appearance: none;
    transition: opacity 0.5s ease;
    background: #1EA5DE;
    border: 0;
    border-radius: 7px;
    overflow: hidden;
    color: #fff;
    cursor: pointer;
    float: left;
    font-size: 20px;
    height: 40px;
    margin: 0;
    width: 40px;
  }
  .EditSceneButtonWidget-commandDelay-button:hover {
    opacity: 0.5;
  }
  .EditSceneButtonWidget-commandDelay-button:hover {
    opacity: 0.5;
  }
  .EditSceneButtonWidget-commandDelay-button:focus {
      outline: 0;
      outline-offset: 0;
  }
  .EditSceneButtonWidget-wrapper-button2 {
    width: calc(100% - 36px);
    margin-top: 25px;
    margin-bottom: 14px;
  }
  .EditSceneButtonWidget-wrapper-commands {
    height: 70px;
    background-color: #FFFFFF;
    padding: 5px;
    margin-top: 14px;
  }
  .EditSceneButtonWidget-wrapper-commands:first-child {
    margin-top: 0;
  }
  .EditSceneButtonWidget-wrapper-command {
    height: 20px;
    line-height: 20px;
  }
  .EditSceneButtonWidget-wrapper-commands-trash {
    left: 5px;
    top: 5px;
    width: 30px;
    height: 30px;
  }
</style>
